import { ServiceItem } from '../service-card-wrapper';

export interface ServiceCardProps {
  className?: string;
  service: ServiceItem;
}

export type StatusType = 'Popular' | 'New' | 'Advance' | 'Soon!' | '';

export enum ServiceType {
  Similarity = 'similarity',
  Semantic = 'semantic',
  People = 'people',
  Analysis = 'analysis',
}
